import { mapGetters } from 'vuex'

export const organisationInit = {
  computed: {
    ...mapGetters({
      schoolOrgId: 'school/schoolOrgId',
      schoolProfile: 'school/schoolProfile',
    }),
  },
  methods: {
    getTitlesAndKeywords() {
      this.$store.dispatch('organisation/FETCH_ORG_TITLES', { organisationId: `${this.schoolOrgId}` })
      this.$store.dispatch('organisation/FETCH_ORG_TITLES', { country: this.schoolProfile?.countryCode })
      this.$store.dispatch('organisation/FETCH_ORG_KEYWORDS', { organisationId: `${this.schoolOrgId}` })
      this.$store.dispatch('organisation/FETCH_ORG_FEATURES', { organisationId: `${this.schoolOrgId}` })
    },
  },
  watch: {
    schoolProfile() {
      this.getTitlesAndKeywords()
    },
  },
  mounted() {
    this.getTitlesAndKeywords()
  },
}
